// Store/api/sportsApi.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from "../customFetchBase";

export const sportsApi = createApi({
  reducerPath: "sportsApi",
  baseQuery: customFetchBase({ url: "sport" }),
  endpoints: (builder) => ({
    // Get all sports with filters
    getSports: builder.query({
      query: (params = {}) => {
        const {
          page = 1,
          limit = 10,
          search,
          isPublished,
          sort = "name",
        } = params;

        let url = `?page=${page}&limit=${limit}&sort=${sort}`;
        if (search) url += `&q=${search}`;
        if (isPublished) url += `&isPublished=${isPublished}`;

        return {
          url,
          method: "GET",
        };
      },
    }),

    // Get single sport by ID
    getSportById: builder.query({
      query: (id) => ({
        url: `/${id}`,
        method: "GET",
      }),
    }),

    // Create new sport
    createSport: builder.mutation({
      query: (data) => ({
        url: "/",
        method: "POST",
        body: data,
      }),
    }),

    // Update sport
    updateSport: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

// Export hooks
export const {
  useGetSportsQuery,
  useGetSportByIdQuery,
  useCreateSportMutation,
  useUpdateSportMutation,
} = sportsApi;
